import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import type { AuthUser } from '@/modules/auth/models/AuthUser';
import type { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';

export class AdvisorUpgradePageViewed extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_UPGRADE_PAGE_VIEWED;

  entryPoint: string;
  userId: number | undefined;
  userRole: string | undefined;
  payingCustomer: boolean | undefined;
  product: ProductKey;

  constructor(entryPoint: string, authUser?: AuthUser, platformProduct?: PlatformProduct) {
    super();

    this.entryPoint = entryPoint;
    this.userId = authUser?.id;
    this.userRole = authUser?.estateAccount?.roleName ?? authUser?.roleName;
    this.payingCustomer = authUser?.isPayingCustomer;
    this.product = platformProduct?.productKey ?? ProductKey.ADVISOR_PRO;
  }

  areAllPropertiesRequired(): boolean {
    return false;
  }
}
